// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1eQhT","col":"styles_col__32z5J"};